import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Youtube } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-neutral-900 py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_exercise-pathway/artifacts/qpkm0mxh_IMG_20251102_132227_965.webp"
                alt="M.Vision Fitness"
                className="h-16 w-16 object-contain"
              />
            </Link>
            <p className="font-manrope text-neutral-500 max-w-md mb-6">
              Transform your vision into reality with personalized fitness programs 
              designed to help you achieve your goals.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 border border-neutral-800 flex items-center justify-center hover:border-white hover:text-white text-neutral-500 transition-colors" data-testid="social-instagram">
                <Instagram size={18} />
              </a>
              <a href="#" className="w-10 h-10 border border-neutral-800 flex items-center justify-center hover:border-white hover:text-white text-neutral-500 transition-colors" data-testid="social-facebook">
                <Facebook size={18} />
              </a>
              <a href="#" className="w-10 h-10 border border-neutral-800 flex items-center justify-center hover:border-white hover:text-white text-neutral-500 transition-colors" data-testid="social-twitter">
                <Twitter size={18} />
              </a>
              <a href="#" className="w-10 h-10 border border-neutral-800 flex items-center justify-center hover:border-white hover:text-white text-neutral-500 transition-colors" data-testid="social-youtube">
                <Youtube size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-oswald uppercase tracking-wider text-sm mb-6">QUICK LINKS</h4>
            <ul className="space-y-3">
              <li>
                <a href="/#about" className="font-manrope text-neutral-500 hover:text-white transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="/#programs" className="font-manrope text-neutral-500 hover:text-white transition-colors">
                  Programs
                </a>
              </li>
              <li>
                <a href="/#pricing" className="font-manrope text-neutral-500 hover:text-white transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <a href="/#contact" className="font-manrope text-neutral-500 hover:text-white transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="font-oswald uppercase tracking-wider text-sm mb-6">PROGRAMS</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/programs" className="font-manrope text-neutral-500 hover:text-white transition-colors">
                  All Programs
                </Link>
              </li>
              <li>
                <Link to="/assessment" className="font-manrope text-neutral-500 hover:text-white transition-colors">
                  Free Assessment
                </Link>
              </li>
              <li>
                <a href="/#testimonials" className="font-manrope text-neutral-500 hover:text-white transition-colors">
                  Success Stories
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-neutral-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-manrope text-neutral-600 text-sm">
            &copy; {currentYear} M.Vision Fitness. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="font-manrope text-neutral-600 text-sm hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="font-manrope text-neutral-600 text-sm hover:text-white transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
